// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".center {\n  text-align: center;\n}\n.text {\n  margin-top: 20px;\n}\n.button-display {\n  display: block;\n}\n\n.button-hide {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
